interface HeroBackgroundProps {
  opacity?: number
  className?: string
}

export const HeroBackground = ({
  opacity = 0.2,
  className = ''
}: HeroBackgroundProps) => {
  return (
    <div className={`absolute inset-0 z-0 w-full ${className}`}>
      <img
        src="/images/hero-map-1280.webp"
        srcSet="/images/hero-map-640.webp 640w, /images/hero-map-1280.webp 1280w, /images/hero-map-2560.webp 2560w"
        sizes="100vw"
        alt=""
        className="absolute inset-0 size-full object-cover"
        style={{ opacity }}
        fetchPriority="high"
        loading="eager"
        decoding="sync"
        width="1280"
        height="800"
      />
      <div className="bg-shire-light absolute inset-0 opacity-60 mix-blend-lighten"></div>
    </div>
  )
}
